//dependencies
import React from "react";

import { faBoxArchive, faTrash } from "@fortawesome/pro-regular-svg-icons";
import { faChartLine, faCheck, faCopy, faPencil, faReply } from "@fortawesome/pro-solid-svg-icons";

// utils
import type { DropDownMenuOption } from "@performyard/py-components";

//components
import Icon from "../../../../../components/Icon/Icon";

//types
import { Goal } from "../../../../../api/services";

import { GoalPermissions } from "../../utils";

// parse through user and user permissinos to generate a list of options for the dropdown menu
export const getGoalDropdownOptions = (goal: Goal, goalPermissions: GoalPermissions): Array<DropDownMenuOption> => {
	const options: DropDownMenuOption[] = [];
	const { status } = goal;
	const isActive = status === "active";
	const {
		userCanCopyGoal,
		userCanDeleteGoal,
		userCanEditDetails,
		userCanEditValue,
		userCanShareGoal,
		userCanEditStatus,
	} = goalPermissions;

	if (userCanEditDetails && isActive) {
		options.push({
			key: "edit",
			right: <Icon size="small" icon={faPencil} />,
			label: "Edit",
			href: `/goal/${goal._id}/edit`,
		});
	}

	if (userCanEditValue && isActive) {
		options.push({
			key: "update",
			right: <Icon size="small" icon={faChartLine} />,
			label: "Update Progress",
		});
	}

	if (userCanShareGoal && isActive) {
		options.push({
			key: "share",
			right: <Icon size="small" icon={faReply} />,
			label: "Share Goal",
		});
	}

	if (userCanCopyGoal) {
		options.push({
			key: "duplicate",
			right: <Icon size="small" icon={faCopy} />,
			label: "Duplicate",
		});
	}

	if (userCanEditStatus && status !== "archived") {
		options.push({
			key: "archive",
			right: <Icon size="small" icon={faBoxArchive} />,
			label: "Archive",
		});
	}

	if (userCanEditStatus && isActive) {
		options.push({
			key: "complete",
			right: <Icon size="small" icon={faCheck} />,
			label: "Mark as Complete",
		});
	}

	if (userCanDeleteGoal && status === "archived") {
		options.push({
			key: "delete",
			right: <Icon size="small" icon={faTrash} />,
			label: "Delete",
		});
	}

	if (userCanEditStatus && !isActive) {
		options.push({
			key: "reopen",
			right: <Icon size="small" icon={faReply} />,
			label: "Reopen",
		});
	}

	return options;
};
